















































import Vue from "vue";
import { Component,  Prop, Watch } from "vue-property-decorator";
import { State, Action, Getter } from "vuex-class";
import { AppConstants as _app } from "@/shared/app.constants";
import FileUpload from '../../Workspace/Components/FileUpload.vue';
import FileDownload from '@/components/common/fileDownload/fileDownload.vue'

@Component({
    components: {
        FileUpload,
        FileDownload
    }
})
export default class GrantDocuments extends Vue {

    @Prop() readOnly: boolean;
    @Prop() grantId: number; 
    @Prop() modelWrapper: any;
    @Prop() docTags: any;

    grantDocsKey: number = 1;

    mounted() {
        this.addEmptyRow();
    }

    get grantDocs() {
        if(this.modelWrapper.agreementDocuments) {
            return this.modelWrapper.agreementDocuments;
        } else {
            this.modelWrapper.agreementDocuments = [ {} ];
            return this.modelWrapper.agreementDocuments
        }
    }

    addEmptyRow(){
        if(this.grantDocs){
            const emptyRow = this.grantDocs.find(x => Object.keys(x).length === 0);
            if(!emptyRow) {
                this.grantDocs.push({});
            }
        }
        this.grantDocsKey += 1;
    }

    onAddFiles(e, doc) {
        const {name, type, size} = e;
        this.$services.document.uploadDocument(e, {
             options: { 
                 docTag: doc.docType,
                 menu: _app.menu.grant  
                 } 
             }, this.grantId, this.$vuetify.lang.current)
        .then((data) => {
            Object.assign(doc, data, {name, type, size });
            // this.$emit('fileChange', doc);
            this.addEmptyRow(); 
            this.$emit('fileChange',e)
        });              
    }
    
    onRemoveFile(index, doc) {
        this.$services.document.removeDocument(doc)
        .then((data) => {
            this.grantDocs.splice(index, 1);
            // this.$emit('fileChange', doc);
            this.addEmptyRow();    
        })

    }
    
}
